import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export const LOGIN_LINK_EXPIRY_MINUTES = 15;

/**
 * Persists the email and timestamp of the last login-link request.
 */
interface LoginRequestState {
  email: string | null;
  requestedAt: number | null;
}

interface LoginRequestActions {
  setLinkRequested: (email: string) => void;
  clearLinkRequest: () => void;
}

type LoginRequestStore = LoginRequestState & LoginRequestActions;

const INITIAL_STATE: LoginRequestState = { email: null, requestedAt: null };

export const useLoginRequestStore = create<LoginRequestStore>()(
  devtools(
    persist(
      (set) => ({
        ...INITIAL_STATE,

        setLinkRequested: (email: string) => {
          set({ email, requestedAt: Date.now() }, false, 'setLinkRequested');
        },

        clearLinkRequest: () => {
          set(INITIAL_STATE, false, 'clearLinkRequest');
        },
      }),
      { name: 'login-request' }
    ),
    { name: 'login-request-store' }
  )
);
